export default [
  {
    path: '/conformite',
    name: 'conformite-list',
    component: () => import('@/views/conformite/Conformite'),
  },
  {
    path: '/conformite/gda',
    name: 'gda-list',
    component: () => import('@/views/conformite/GDA'),
  },
  {
    path: '/conformite/guide',
    name: 'conformite-guide',
    component: () => import('@/views/outils/guide/MasterGuide.vue'),
  },
]
